module.exports = __webpack_public_path__ + "static/media/img-01.1fb35a43.jpg";